<div class="main-wrapper">
  <div class="auth-sidebar">
    <div class="header">

      <a [routerLink]="session_info?.last_routes.new_home || '/'">
        <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
      </a>
      <h3>QR code-accessible web pages for all use cases</h3>
    </div>
  </div>
  <div class="auth-contents">
    <div class="form-contents" *ngIf="login_form">
      <form #loginForm="ngForm" [formGroup]="login_form" (ngSubmit)="tryLogin()">
        <ng-container *ngIf="authState$ | async; let auth_state">
          <ng-container *ngIf="auth_state.responses.login?.token_type !== 'otp'; else requiresOTP">
            <div class="form-header">
              <a [routerLink]="session_info?.last_routes.new_home || '/'" class="d-lg-none">
                <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
              </a>
              <h2>Sign in</h2>
              <p class="lg">Don't have an account? <a routerLink="/auth/signup">Sign up</a></p>
            </div>
            <app-auth-google></app-auth-google>
            <div class="line">
              <span>OR</span>
              <hr />
            </div>
            <div class="mb-3">
              <label class="form-label bold">Email</label>
              <input type="email" formControlName="email"
                [class.is-invalid]="((login_form.get('email').hasError('required') || login_form.get('email').hasError('email')) && login_form.get('email').touched) || auth_state.error"
                required class="form-control">
              <ng-container *ngIf="login_form.get('email').touched">
                <p class="input-error" *ngIf="login_form.get('email').hasError('required')">
                  Email is required!</p>
                <p class="input-error" *ngIf="login_form.get('email').hasError('email')">
                  Email is invalid!</p>
              </ng-container>
            </div>
            <div class="mb-2">
              <label class="form-label bold">Password</label>
              <input type="password" formControlName="password"
                [class.is-invalid]="(login_form.get('password').hasError('required') && login_form.get('password').touched) || auth_state.error"
                required class="form-control">
              <ng-container *ngIf="login_form.get('password').touched">
                <p class="input-error" *ngIf="login_form.get('password').hasError('required')">
                  Password is required!</p>
              </ng-container>
              <ng-container *ngIf="auth_state.error">
                <p class="input-error">
                  {{auth_state.error}}</p>
              </ng-container>
            </div>
            <div class="text-end mb-3">
              <a routerLink="/auth/resetpass">Forgot password?</a>
            </div>
            <button class="btn btn-secondary btn-block mt-4"
              [disabled]="auth_state.status === state_statuses.PROCESSING">
              <app-inline-loader
                *ngIf="auth_state.status === state_statuses.PROCESSING && auth_state.data.auth_type === auth_types.EMAIL; else notProcessing"></app-inline-loader>
              <ng-template #notProcessing>
                <span>Login</span>
              </ng-template>
            </button>
          </ng-container>
          <ng-template #requiresOTP>
            <app-auth-otp [data]="login_form" (submit_clicked)="tryLogin()"></app-auth-otp>
          </ng-template>
        </ng-container>
      </form>
    </div>
  </div>
</div>